import { Component } from '@angular/core';
import { soundpostAccountingScheduleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Accounting Schedules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingschedule-form',
    templateUrl: './soundpostaccountingschedule.form.component.html'
})
export class soundpostAccountingScheduleFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingScheduleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingSchedules', sectionName: 'Accounting Schedules', isExpanded: false }
        ]);
    }
}

